module.exports = __webpack_public_path__ + "static/img/teamDataCardBg2.b77e238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/teamDataCardBg2.png
// module id = EnVs
// module chunks = 0